// product grid/list
// function listgridJavascript() {
// Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
//     link.addEventListener('click', function(event) {
//         Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
//         this.classList.add('active');
//         if(this.classList.contains('listv')){
//             document.getElementById('product-grid').classList.add('product-list');
//             document.getElementById('product-grid').classList.remove('product-grid');
//             document.getElementById('product-grid').classList.remove('product-gallery');
//             // Remove 'active' class from gridv on mobile
//               if (window.innerWidth < 992) { 
//                 document.querySelector(".gridv").classList.remove('active_mobile'); 
//               }  
//         }else if(this.classList.contains('gridv')){
//             document.getElementById('product-grid').classList.add('product-grid');
//             document.getElementById('product-grid').classList.remove('product-list');
//             document.getElementById('product-grid').classList.remove('product-gallery');
//         }else if(this.classList.contains('galleryv')){
//             document.getElementById('product-grid').classList.add('product-gallery');
//             document.getElementById('product-grid').classList.remove('product-list');
//             document.getElementById('product-grid').classList.remove('product-grid');
//         }
//     });
// });
// };
// document.addEventListener("shopify:section:load", listgridJavascript);
// listgridJavascript();

function layoutSwitcher() {
  Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
    link.addEventListener('click', toggle);
    link.addEventListener('keydown', handleKeyDown);
  });
};
function handleKeyDown(event){
  if (event.keyCode === 13) {
    toggle(event);
  }
}
function toggle(event){
  const target = event.currentTarget;
  const container = document.getElementById('ProductGridContainer');
  const grid = document.getElementById('product-grid');
  if (!container) return;

  Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
  target.classList.add('active');

  if (target.classList.contains('listv')) {
    container.classList.add('product-list');
    container.classList.remove('product-grid', 'product-gallery');
    if (grid) grid.classList.add('product-list');
    if (grid) grid.classList.remove('product-grid', 'product-gallery');
    if (window.innerWidth < 992) {
      const gridBtn = document.querySelector(".gridv");
      if (gridBtn) gridBtn.classList.remove('active_mobile');
    }
  } else if (target.classList.contains('gridv')) {
    container.classList.add('product-grid');
    container.classList.remove('product-list', 'product-gallery');
    if (grid) {
      grid.classList.add('product-grid');
      grid.classList.remove('product-list', 'product-gallery');
    }
  } else if (target.classList.contains('galleryv')) {
    container.classList.add('product-gallery');
    container.classList.remove('product-list', 'product-grid');
    if (grid) {
      grid.classList.add('product-gallery');
      grid.classList.remove('product-list', 'product-grid');
    }
  }
}
document.addEventListener("shopify:section:load", layoutSwitcher);
layoutSwitcher();


// on scroll play video
window.addEventListener('load', videoScroll);
window.addEventListener('scroll', videoScroll);
function videoScroll() {
  if ( document.querySelectorAll('video[autoplay]').length > 0) {
    var windowHeight = window.innerHeight, videoEl = document.querySelectorAll('video[autoplay]');
    for (var i = 0; i < videoEl.length; i++) {
      var thisVideoEl = videoEl[i],
          videoHeight = thisVideoEl.clientHeight,
          videoClientRect = thisVideoEl.getBoundingClientRect().top;
      if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5 ) ) ) {
        thisVideoEl.play();
      } else {
        thisVideoEl.pause();
      }
    }
  }
}

// timer
// ED 2026-10-23: the cart-drawer countdown used a fixed end date (theme setting, expired 25 Aug 2026)
// so it sat at 00:00:00:00. With data-ed-dispatch it counts to the next dispatch cutoff instead:
// <hour>:00 Europe/Copenhagen on the next working day (Mon-Fri, excluding Danish public holidays), same rule as the ED dispatch bar.
function edZonedParts(date, tz) {
  var parts = new Intl.DateTimeFormat('en-GB', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).formatToParts(date);
  var m = {};
  parts.forEach(function (p) { if (p.type !== 'literal') m[p.type] = parseInt(p.value, 10); });
  return m;
}
function edZonedToMs(y, mo, d, h, tz) {
  var guess = Date.UTC(y, mo - 1, d, h, 0, 0);
  for (var i = 0; i < 3; i++) {
    var p = edZonedParts(new Date(guess), tz);
    guess += Date.UTC(y, mo - 1, d, h, 0, 0) - Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
  }
  return guess;
}
function edNextDispatchMs(now, hour) {
  var tz = 'Europe/Copenhagen';
  var p = edZonedParts(now, tz);
  var hol = (typeof window !== 'undefined' && window.edDkHoliday) || (typeof edDkHoliday === 'function' ? edDkHoliday : null);
  for (var i = 0; i < 21; i++) {
    var c = new Date(Date.UTC(p.year, p.month - 1, p.day + i));
    var wd = c.getUTCDay();
    if (wd === 0 || wd === 6) continue;
    if (hol && hol(c.getUTCFullYear(), c.getUTCMonth() + 1, c.getUTCDate())) continue; // helligdage (assets/ed-dk-holidays.js)
    var t = edZonedToMs(c.getUTCFullYear(), c.getUTCMonth() + 1, c.getUTCDate(), hour, tz);
    if (now.getTime() < t) return t;
  }
  return NaN;
}
/* 2026-10-23: Enter in a cart (drawer or cart page) quantity box must update the quantity, not submit
   the cart form (which goes to checkout). Capture phase so it runs before the implicit form submit. */
function edCartQtyEnter(event) {
  if (!event || (event.key !== 'Enter' && event.keyCode !== 13)) return false;
  var t = event.target;
  if (!t || !t.matches || !t.matches('input.quantity__input, input[name="updates[]"]')) return false;
  if (!t.closest || !t.closest('cart-drawer, cart-drawer-items, cart-items, #CartDrawer, #cart, .cart-drawer, form[action*="/cart"]')) return false;
  event.preventDefault();
  if (event.stopPropagation) event.stopPropagation();
  try {
    t.dispatchEvent(new Event('change', { bubbles: true }));
  } catch (e) {}
  return true;
}
if (typeof document !== 'undefined' && document.addEventListener) {
  document.addEventListener('keydown', edCartQtyEnter, true);
}
if (typeof module !== 'undefined' && module.exports) module.exports = { edNextDispatchMs: edNextDispatchMs, edCartQtyEnter: edCartQtyEnter };
setInterval(countDown, 1000);
function countDown() {
  const countCardSections = document.querySelectorAll('.countd_all');
  countCardSections.forEach((countdownSection) => {
    var countDownDate = countdownSection.hasAttribute('data-ed-dispatch')
      ? edNextDispatchMs(new Date(), parseInt(countdownSection.getAttribute('data-ed-dispatch'), 10) || 12)
      : new Date(countdownSection.getAttribute('data-date').replaceAll('-','/')).getTime();
    var now = new Date().getTime();
    var distance = countDownDate - now;
    if (distance < 0 || isNaN(countDownDate)) {
      countdownSection.querySelector('.main_cdays .wb_cdays').textContent = "00";
      countdownSection.querySelector('.main_chours .wb_chours').textContent = "00";
      countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = "00";
      countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = "00";
    }
    else {
      var pad2 = function (n) { return String(n).padStart(2, '0'); };
      countdownSection.querySelector('.main_cdays .wb_cdays').textContent = pad2(Math.floor(distance / (1000 * 60 * 60 * 24)));
      countdownSection.querySelector('.main_chours .wb_chours').textContent = pad2(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
      countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = pad2(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)));
      countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = pad2(Math.floor((distance % (1000 * 60)) / 1000));
    }
  });
}